import { Table } from "antd";
import { toastError } from "@/shared/lib/toast";
import type { ColumnsType } from "antd/es/table";
import { adminQueryKeys, fetchAdminClinicians } from "@/portals/admin/api/adminQueryKeys";
import { useCachedQuery } from "@/shared/hooks/useCachedQuery";
import type { ClinicianListItem } from "@/portals/clinician/api/types";
import { clinicianInitials, clinicianName } from "@/portals/clinician/lib/clinicianName";
import { formatDate } from "./formatDate";

const columns: ColumnsType<ClinicianListItem> = [
  {
    title: "Name",
    key: "name",
    // Same avatar + name cell as the Patients table (patient-portal indigo).
    render: (_, p) => (
      <div className="flex items-center gap-3">
        <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#180047] text-[11px] font-bold text-white">
          {clinicianInitials(p)}
        </div>
        <p className="!mb-0 text-sm font-extrabold text-[#0A2947]">{clinicianName(p)}</p>
      </div>
    ),
  },
  { title: "Email", dataIndex: "email", key: "email" },
  { title: "Joined", dataIndex: "joinedAt", key: "joinedAt", render: formatDate },
];

export function CliniciansTab() {
  // Cached: switching tabs or pages and coming back shows the list at once, then refreshes it quietly.
  const { data: items = [], loading } = useCachedQuery(adminQueryKeys.clinicians, fetchAdminClinicians, {
    onError: (error) => toastError(error?.message ?? "Unable to load clinicians."),
  });

  return (
    <div className="flex flex-col gap-4">
      <Table<ClinicianListItem>
        rowKey="userId"
        columns={columns}
        dataSource={items}
        loading={loading}
        pagination={{ pageSize: 10, hideOnSinglePage: true }}
        locale={{ emptyText: "No clinicians have joined yet." }}
        scroll={{ x: 520 }}
      />
    </div>
  );
}
